










import { Vue, Component } from "vue-property-decorator";

@Component
export default class CardDock extends Vue {
  hasRightCol() {
    return !!this.$slots.rightCol || !!this.$scopedSlots.rightCol;
  }
}
